<header class="header">
    <app-navbar [startPageUrl]="startPageUrl" [hideStartActionOnStartPage]="true" [showPauseActionWithinTask]="false"
        [showSettings]="false" logoUrl="assets/logo.svg" />
</header>
